module.exports = __webpack_public_path__ + "static/media/raaksha.bdd6837f.jpg";